import { FC, memo } from "react";
import { MatchStatus } from "service";
import styled from "styled-components";
import { SIDE } from "_constants";
import { getTeamColors } from "components/colors";
import { isThreePointCode } from "../constants";

export const ThreePointsIndicator: FC<{ status: MatchStatus }> = memo(
  ({ status: { nsc, side, ...status } }) => {
    const isThreePoints = isThreePointCode(nsc);

    const { home, away } = getTeamColors(status as any);
    const fillColor = side === SIDE.HOME ? home : away;

    if (!isThreePoints) return null;

    const PATH_D =
      "M400 180H0V158H35.5C35.5 158 65.5 157 87 144C108.5 131 121.5 115 121.5 89.5C121.5 64 106.633 49 88 36C69.3702 23.0024 35.5127 21.0008 35.5 21H0V0H400V180ZM0 158H-0.5V21H0V158Z";

    return (
      <PathContainer className="attack-indicator">
        <svg
          width="100%"
          height="100%"
          viewBox="0 0 400 180"
          preserveAspectRatio="none"
        >
          <path
            d={PATH_D}
            fill={fillColor}
            opacity={0.5}
            transform={
              String(side) === String(SIDE.HOME)
                ? "translate(1024 0) scale(-1 1)"
                : undefined
            }
          />
        </svg>
      </PathContainer>
    );
  }
);

const PathContainer = styled.div`
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
  padding: 1vw;

  & > svg {
    width: 100%;
    height: 100%;
    display: block;
  }
`;
